enum ScheduleReminderType {
  WORK = 'work',
  BREAK = 'break',
}

export default ScheduleReminderType;
